import React from 'react';
import logComponent from '../../common/logComponent';

export default function defaultMonitoredIndividualIcon() {
  if (logComponent('defaultMonitoredIndividualIcon')) { console.debug('defaultMonitoredIndividualIcon render'); }

  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="1 1 28 23" xmlSpace="preserve" preserveAspectRatio="xMidYMid slice" height="100%" width="100%">
      <path fill="#D8D8D8" d="M12,16.2c-2-1.1-3.4-3.2-3.4-5.6c0-3.5,2.9-6.4,6.4-6.4s6.4,2.9,6.4,6.4c0,2.5-1.4,4.6-3.4,5.6
        c3.7,1,6.7,4,7.6,7.8c2.1-2.5,3.4-5.6,3.4-9.1c0-7.7-6.3-14-14-14S1,7.2,1,14.9c0,3.5,1.3,6.7,3.4,9.1C5.4,20.3,8.3,17.3,12,16.2z"
        />
    </svg>
  );
}